// import the react components
import React, {useState} from "react";

// import the custome components
import Modal from "./../modal";
import TextEditor from "./../../components/text-editor";

// import the styles
import {input_style} from "./../../assets/data/style";

// import the api components
import axios from "axios";
import {NOTE_API} from "./../../assets/data/api";

// import the context
import {useStateContext} from "./../../context/";

// the note modal functional based component
const NoteModal = () => {
    const {set_note_modal, selected_note, set_selected_note, is_loged, dispatch_note, set_alert} = useStateContext();
    const [state, set_state] = useState({
        title: selected_note ? selected_note.title : "",
        description: selected_note ? selected_note.description : "",
        type: selected_note ? selected_note.type : "note",
    });

    // close the modal
    const handle_close = () => {
        set_note_modal(false);
        set_selected_note(null);
    };

    // handle the create and update
    const handle_submit = () => {

        // prepare the query
        const endpoint = NOTE_API + `${selected_note ? "update.php" : "create.php"}`;
        const {title, description, type} = state;
        const data = {
            id: selected_note ? selected_note.id : "",
            uniq: selected_note ? selected_note.uniq : "",
            username: is_loged.username,
            title,
            description,
            type,
        };

        // send the query to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){
                selected_note ? dispatch_note({type: "update", payload: data.note}) : dispatch_note({type: "push", payload: data.note});
                set_alert({type: "success", text: "the note saved successfully"});
                handle_close();
            }

            // if the error occured
            else if (data.error) set_alert({type: "error", text: data.error});
        })
    };

    // handle the delete
    const handle_delete = () => {

        // prepare the query
        const endpoint = NOTE_API + "delete.php";
        const data = {id: selected_note.id};

        // send the query to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){
                dispatch_note({type: "delete", payload: selected_note});
                set_alert({type: "success", text: "the note deleted successfully"});
                handle_close();
            }

            // if the error occured
            else if (data.error) set_alert({type: "error", text: data.error});
        });
    };

    // the footer buttons
    const buttons = [
        {
            title: "save",
            handler: handle_submit,
        },
    ];
    selected_note && buttons.unshift({
        title: "delete",
        handler: handle_delete,
    });

    // extract the data
    const {title, description, type} = state;

    // the otions for the note
    const options = ["note", "instruction", "prescription"];

    // return to the component data
    return (
        <Modal handle_close={handle_close} buttons={buttons} z_index={10}>
            <div className="grid grid-cols-1 gap-y-4">
                <input
                    type="text"
                    name="title"
                    placeholder="set the title"
                    value={title}
                    onChange={event => set_state({...state, title: event.target.value})} 
                    required
                    className={`${input_style}`}
                />

                <TextEditor html={description} placeholder="set the description" handler={event => set_state({...state, description: event.target.value})} />

                <select className={input_style} value={type} onChange={event => set_state({...state, type: event.target.value})}>
                    {options.map(item => <option key={item} value={item}>{item}</option>)}
                </select>
            </div>
        </Modal>
    );
};
export default NoteModal;